import { useState } from 'react';
import { X, Maximize2, Minimize2 } from 'lucide-react';

interface DemoContainerProps {
  title: string;
  description: string;
  children: React.ReactNode;
  isOpen: boolean;
  onClose: () => void;
}

const DemoContainer = ({ title, description, children, isOpen, onClose }: DemoContainerProps) => {
  const [isFullscreen, setIsFullscreen] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm">
      <div 
        className={`relative bg-background border border-white/10 rounded-2xl shadow-2xl transition-all duration-300 ${
          isFullscreen ? 'w-full h-full' : 'w-full max-w-6xl h-[85vh]'
        }`}
      >
        {/* Header */}
        <div className="flex items-center justify-between p-4 border-b border-white/10">
          <div>
            <h3 className="text-xl font-heading font-bold text-white">
              {title}
            </h3>
            <p className="text-sm text-gray-400 mt-1">
              {description}
            </p>
          </div>
          
          <div className="flex items-center gap-2">
            <button
              onClick={() => setIsFullscreen(!isFullscreen)}
              className="p-2 rounded-lg hover:bg-white/10 transition-colors"
              aria-label={isFullscreen ? 'Minimizar' : 'Maximizar'}
            >
              {isFullscreen ? (
                <Minimize2 className="w-5 h-5 text-gray-400" />
              ) : (
                <Maximize2 className="w-5 h-5 text-gray-400" />
              )}
            </button>
            
            <button
              onClick={onClose}
              className="p-2 rounded-lg hover:bg-white/10 transition-colors"
              aria-label="Fechar"
            >
              <X className="w-5 h-5 text-gray-400" />
            </button>
          </div>
        </div>

        {/* Content */}
        <div className="h-[calc(100%-73px)] overflow-hidden">
          {children}
        </div>
      </div>
    </div>
  );
};

export default DemoContainer;
